import { selectFromOrganizationDto } from '../../models';

export default selectFromOrganizationDto()
  .id
  .name
  .address
  .phoneNumber
  .customerFacingEmail
  .website
  .logoUrl
  .brandColor
  .settings(settings => settings
    .organizationId
    .dateTimeFormat
    .distanceUnit
    .dateFormatPreference
    .allowDriverOutOfSequence)
  .toString();
